(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-grid"] && !Shopify.designMode) return;
  try {
    
(function(){
  const HEX = '{{ section.settings.text_color }}';
  const RGB = '{{ section.settings.text_color | color_to_rgb | remove:"rgb(" | remove:")" }}';

  function paint(root){
    if(!root) return;
    // Ensure product-card scope variables resolve to your text color
    root.querySelectorAll('.product-item, .product-card, .product-card__info, .product-item__meta, .price').forEach(el=>{
      el.style.setProperty('--color-foreground', RGB, 'important');
      el.style.setProperty('--color-body', RGB, 'important');
      el.style.setProperty('--text', RGB, 'important');
      el.style.setProperty('--color-price', RGB, 'important');
      el.style.setProperty('--color-sale-price', RGB, 'important');
      el.style.setProperty('--price-color', RGB, 'important');
      el.style.setProperty('--price-regular', RGB, 'important');
      el.style.setProperty('--price-sale', RGB, 'important');
      el.style.setProperty('--compare-at-price-color', RGB, 'important');
    });

    // Inline-style every price piece so it wins the cascade
    root.querySelectorAll('.price, .price *, [itemprop="price"]').forEach(el=>{
      el.style.setProperty('color', HEX, 'important');
      el.style.setProperty('-webkit-text-fill-color', HEX, 'important');
    });
  }

  const section = document.querySelector('.featured-collection-grid[data-section-id="{{ section.id }}"]');
  paint(section);

  // Re-apply when the section re-renders (Theme Editor, quick-add, slider updates, etc.)
  if (section) {
    new MutationObserver(()=>paint(section)).observe(section, {subtree:true, childList:true});
  }
  document.addEventListener('shopify:section:load', (e)=>{
    if (e.target && e.target.matches('.featured-collection-grid[data-section-id="{{ section.id }}"]')) {
      paint(e.target);
    }
  });
})();


  } catch(e) { console.error(e); }
})();
})();
